import TeamTable from "../TeamTable";

const Distnace70 = () => {
  return <TeamTable  distance={"70"} targetType={"PRE"}/>;
};
export default Distnace70;
